import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { declination, getTranslateProps } from '../../utils';

const MovieListItem = ({movie: { id, title, poster, age_category, parameters }, genres, premiere }) => {
    return (
        <li className='filmik__films-item'>
            <Link className='filmik__films-link' to={`/desc/${id}`}>
                <img className='filmik__films-image' src={poster} alt='poster' />
                <p className='filmik__films-name'>{title}</p>
                <p className='filmik__films-genres'>{ genres.join(', ') }</p>
                <div className='filmik__films-year-age'>{parameters[2].slice(5)} | {age_category}+</div>
                {premiere}
            </Link>
        </li>
    );
};

MovieListItem.propTypes = {
    movie: PropTypes.object.isRequired,
    genres: PropTypes.array.isRequired,
    premiere: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.oneOf([null]).isRequired]),
};

const MovieListItemContainer = ({movie}) => {
    let genres = [];

    movie.parameters[0].slice(6).split(',').forEach((genre) => {
        genres.push(getTranslateProps('genre', genre));
    });

    const endingsDays = ['ень', 'ня', 'ней'];
    const countDay = Math.floor((new Date(movie.released) - new Date()) / 86400000);
    const premiere = ((new Date(movie.released) - new Date()) > 0) ? <div className='filmik__films-premiere'>До премьеры: {countDay} д{declination(countDay, endingsDays)}</div> : null;

    return (
        <MovieListItem
            movie={movie}
            genres={genres}
            premiere={premiere}
        />
    );
};

MovieListItemContainer.propTypes = {
    movie: PropTypes.object.isRequired,
};

export default MovieListItemContainer;